import React, { useState } from 'react';
import { Form, Button, Container, Row, Col } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Link } from "react-router-dom";

const RevenueCentersReportForm = () => {
  const [formData, setFormData] = useState({
    startDate: '2024-09-01',
    endDate: '2024-09-30',
    practice: [],
    tags: [],
    includeClosed: false,
    format: '',
  });

  const handleChange = (e) => {
    const { name, value, type, checked, options } = e.target;
    if (type === 'checkbox') {
      setFormData(prevState => ({
        ...prevState,
        [name]: checked
      }));
    } else if (type === 'select-multiple') {
      const values = Array.from(options).filter(option => option.selected).map(option => option.value);
      setFormData(prevState => ({
        ...prevState,
        [name]: values
      }));
    } else {
      setFormData(prevState => ({
        ...prevState,
        [name]: value
      }));
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    
  };

  return (
    <Container className="mt-4" style={{ maxWidth: '600px' ,marginLeft:"0px"}}>
      <Form onSubmit={handleSubmit} className="p-4 border rounded">
        <fieldset>
          <legend>Parameters</legend>

          {/* Start Date */}
          <Form.Group as={Row} controlId="startDate" className="mb-3">
            <Form.Label column sm="4" title="Please choose a start date to report on">
              Start Date <span className="text-danger">*</span>
            </Form.Label>
            <Col sm="8">
              <Form.Control
                type="date"
                name="startDate"
                value={formData.startDate}
                onChange={handleChange}
                required
              />
            </Col>
          </Form.Group>

          {/* End Date */}
          <Form.Group as={Row} controlId="endDate" className="mb-3">
            <Form.Label column sm="4" title="Please choose an end date to report on">
              End Date <span className="text-danger">*</span>
            </Form.Label>
            <Col sm="8">
              <Form.Control
                type="date"
                name="endDate"
                value={formData.endDate}
                onChange={handleChange}
                required
              />
            </Col>
          </Form.Group>

          {/* Accounts */}
          <Form.Group as={Row} controlId="practice" className="mb-3">
            <Form.Label column sm="4" title="Please choose an account to limit the report to">
              Accounts
            </Form.Label>
            <Col sm="8">
              <Form.Control
                as="select"
                name="practice"
                multiple
                value={formData.practice}
                onChange={handleChange}
                className="form-select"
              >
                <option value="">All</option>
                <option value="144545">2ingis s.a.</option>
                <option value="71159">ALL SAINTS DENTAL</option>
                <option value="137334">Andrew Lee (Diu Resh)</option>
                <option value="109766">Andrew Lee Dental (Roebuck Louise)</option>
              </Form.Control>
            </Col>
          </Form.Group>

          {/* Include Closed Checkbox */}
          <Form.Group as={Row} className="mb-3">
            <Form.Label column sm="4">&nbsp;</Form.Label>
            <Col sm="8">
              <Form.Check
                type="checkbox"
                name="includeClosed"
                checked={formData.includeClosed}
                onChange={handleChange}
                label="Include Closed"
              />
            </Col>
          </Form.Group>

          {/* Account Tags */}
          <Form.Group as={Row} controlId="tags" className="mb-3">
            <Form.Label column sm="4" title="Select tags to filter report">
              Account Tags
            </Form.Label>
            <Col sm="8">
              <Form.Control
                as="select"
                name="tags"
                multiple
                value={formData.tags}
                onChange={handleChange}
                className="form-select"
              >
                <option value="">No filter</option>
                <option value="a-practices">a-practices</option>
                <option value="bhandal">bhandal</option>
                <option value="coventry-dental">coventry-dental</option>
                <option value="dental-beauty">dental-beauty</option>
                <option value="murray-dental-">murray-dental-</option>
                <option value="swissmeda">swissmeda</option>
              </Form.Control>
            </Col>
          </Form.Group>

          {/* Format */}
          <Form.Group as={Row} controlId="format" className="mb-3">
            <Form.Label column sm="4" title="Please choose a display format">
              Format <span className="text-danger">*</span>
            </Form.Label>
            <Col sm="8">
              <Form.Control
                as="select"
                name="format"
                value={formData.format}
                onChange={handleChange}
                className="form-select"
                required
              >
                <option value="">On Screen</option>
                <option value="csv">CSV (Excel)</option>
              </Form.Control>
            </Col>
          </Form.Group>

          {/* Submit Button */}
          <Form.Group as={Row} className="mb-0">
            <Col sm={{ span: 8, offset: 4 }}>
            <Link to="/Addpaymentaccounts">
              <Button
                type="submit"
                variant="primary"
                className="w-100"
                style={{
                  backgroundColor: '#004aad',
                  borderColor: '#004aad',
                  marginTop: '10px',
                }}
              >
                <span className="ico-search"></span> Run
              </Button>
              </Link>
            </Col>
          </Form.Group>
        </fieldset>
      </Form>
    </Container>
  );
};

export default RevenueCentersReportForm;
